import React, { useEffect } from "react";
import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import { getMarketResearchData } from "../../services/api.service";

import { useRef } from "react";
import { mapThemeIntelliegence } from "../../assets/map/theme";
import HoverSvg from "../../assets/images/hover.svg";
import portMarkerSvg from "../../assets/images/port.svg";
import greenMarker from "../../assets/images/green.svg";
import redMarker from "../../assets/images/red.svg";
import countryMarkerSvg from "../../assets/images/country.svg";
import InfoWindow from "react-google-maps/lib/components/InfoWindow";
import Polygon from "react-google-maps/lib/components/Polygon";
import { useContext } from "react";
import Loader from "../common/loader";
import { intelliegenceContext } from "../../states/context/intelliegenceContext";
import InfoWindowNews from "./side-bar/InfoWindowNews";
import PortInfowWindow from "./side-bar/PortInfoWindow";
import GeoJSON from "../../assets/map/countries.json";
import SupplierInfoWindow from "./side-bar/SupplierInfoWindow";

const exampleMapStyles = mapThemeIntelliegence;
const mapEnvironment = compose(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyBt2A7MkqDnWTXzFhNE5qfOySw-3in8aTM",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: (
      <div
        className="map-container"
        id="map"
      />
    ),
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
);

const MapLayout = (props) => {
  const mapRef = useRef(null);
  const context = useContext(intelliegenceContext);

  useEffect(() => {
    fitBounds();
  }, []);

  // Iterate myPlaces to size, center, and zoom map to contain all markers
  const fitBounds = () => {
    window["intelliegenceMap"] = mapRef;
  };
  const getCoordinates = (country) => {
    try {
      let indx;
      let maxLength = 0;
      const geoJsonFilter = GeoJSON.features.filter(
        (geo) => geo.properties.ADMIN === country
      )[0].geometry.coordinates;

      geoJsonFilter.forEach((d, i) => {
        if (d[0].length > maxLength) {
          maxLength = d[0].length;
          indx = i;
        }
      });

      const coordinates = geoJsonFilter[indx][0].map((loc) => {
        return {
          lat: loc[1],
          lng: loc[0],
        };
      });

      return coordinates;
    } catch (e) {
      return [];
    }
  };
  const updateFitBounds = (markerLocation) => {
    const map = window.intelliegenceMap;
    const bounds = new window.google.maps.LatLngBounds();
    const markers = markerLocation;
    markers
      .filter((marker) => marker.marker_priority === 1)
      .map((place) => {
        bounds.extend({ lat: place.lat, lng: place.lng });
        return place.item_id;
      });
    map.current.fitBounds(bounds);

    return markers;
  };

  const getMarkerData = async (country) => {
    const markerPayLoad = context.markerPayload;
    markerPayLoad.location = country;
    markerPayLoad.location_type = "country";
    markerPayLoad.start_date = ""
    markerPayLoad.end_date = ""
    const payLoad = {
      api_name: "public_risk_marker",
      data: markerPayLoad,
    };

    const data = await getMarketResearchData(payLoad);
    return data;
  };

  const loadCountryData = async (country) => {
    try {
      context.setLoaderStatus(true);
      context.setLocation({
        label: country,
        value: country,
        type: "country"
      });
      context.setMapMount(true);
      const { meta, data } = await getMarkerData(country);
      if (meta.status !== 200) return;
      if (!data.marker_location.length) {
        context.setMapLocation({
          lng: 35.5994,
          lat: 20.6731,
        });
        // const markers = updateFitBounds([]);
        context.setMarkerLocation([]);
        context.setMapMount(false);
        context.setLoaderStatus(false);
        context.setNotificationMessage(
          "No data for the selected parameters.Please select other location, topic or date"
        );
        return;
      }

      /**Mock data used for the port location to demo purpose */
      // const portMarker = portLocation.filter((port) => {
      //   if (port.data.country === country) {
      //     return port;
      //   }
      // });

      const markers = await updateFitBounds([
        ...data.marker_location,
        // ...countryMarkerLocation,
        // ...portMarker,
      ]);
      context.setMarkerLocation(markers);
      context.setLoaderStatus(false);
    } catch (error) {
      context.setMapLocation({
        lng: 160.7077,
        lat: 38.8776,
      });
      context.setMarkerLocation([]);
      context.setLoaderStatus(false);
      context.setMapMount(false);
      context.setNotificationMessage(
        "No data for the selected parameters.Please select other location, topic or date"
      );
    }
  };
  const onMapClick = async (e) => {
    try {
      let country;
      let type;
      const geoCoder = new window.google.maps.Geocoder();
      await geoCoder.geocode({ latLng: e.latLng }, function (results, status) {
        if (status == window.google.maps.GeocoderStatus.OK) {
          console.log("results", results);
          country = results[results.length - 1].formatted_address;
          type = results[results.length - 1].geometry.location_type;
        } else {
          console.log("error");
          throw results;
        }
      });

      const coordinates = await getCoordinates(country);
      context.setCoordinates(coordinates);

      if (type === "APPROXIMATE") return loadCountryData(country);
    } catch (error) {
      throw error.message;
    }

    this.setState({
      activeMarkerId: null,
      infoWindow: false,
    });
    this.context.setActiveMarkerId(null);
    this.handleBoundsChanged();
    const _markers = this.context.markerLocation.map((marker) => {
      marker.hover = false;
      return marker;
    });
    this.context.setMarkerLocation(_markers);
  };

  const onMarkerClick = (i, location) => {
      context.setActiveMarkerId(i);
      context.setInfoWindowIsShow(true);
    props.onClickMarker(i, location);
    const _drawer = context.drawer;
    _drawer.news = false;

    context.setDrawer(_drawer);
  };

  return (
    <GoogleMap
      ref={mapRef}
      zoom={3}
      defaultCenter={{
        lat: context.mapLocation.lat,
        lng: context.mapLocation.lng,
      }}
      defaultOptions={{
        styles: exampleMapStyles,
        maxZoom: 8,
        minZoom: 1.6,
      }}
      onClick={onMapClick}
      onBoundsChanged={props.onBoundsChanged}
    >
      {context.markerLocation.map((location, i) => {
        let marker;
        if (location.marker_type === "supplier") marker = greenMarker;
        if (location.marker_type === "news") marker = redMarker;
        if (location.marker_type === "port") marker = portMarkerSvg;
        if (location.marker_type === "country") marker = countryMarkerSvg;
        if (location.marker_type === "news" && location?.hover)
          marker = HoverSvg;
        return (
          <Marker
            position={{ lat: location.lat, lng: location.lng }}
            icon={{
              url: marker,
              ...(context.activeMarkerId == i && {
                scaledSize: { width: 40, height: 40 },
              }),
            }}
            key={i}
            onClick={(event) => {
              onMarkerClick(i, location);
            }}
            visible={location.marker_visible}
          >
            {context.activeMarkerId === i &&
              location.marker_type === "news" &&
              context.infoWindowIsShow && (
                <InfoWindow onCloseClick={() => props.infoWindoOnClose()}>
                  <InfoWindowNews
                    context={context}
                    newsInfo={location.data}
                    location={location}
                  />
                </InfoWindow>
              )}
            {context.activeMarkerId === i &&
              location.marker_type === "supplier" &&
              context.infoWindowIsShow && (
                <InfoWindow onCloseClick={() => props.infoWindoOnClose()}>
                  <SupplierInfoWindow
                      supplierInfo={location.data}
                      context={context}
                      location={location}
                    />
                </InfoWindow>
              )}
            {context.activeMarkerId === i &&
              location.marker_type === "port" &&
              context.infoWindowIsShow && (
                <InfoWindow onCloseClick={() => props.infoWindoOnClose()}>
                  <PortInfowWindow
                      portInfo={location.data}
                      context={context}
                      location={location}
                    />
                </InfoWindow>
              )}
            {context.activeMarkerId === i && context.messageToast.status && (
              <InfoWindow onCloseClick={() => props.infoWindoOnClose()}>
                {/* <ToastWindowInfo
                      message={context.messageToast.message}
                      content={context.messageToast.content}
                    /> */}
              </InfoWindow>
            )}
          </Marker>
        );
      })}
      {/* {context.mapMount ? (
                ""
            ) : (
                <Notification message={context.notificationMessage} />
            )} */}
      {context.loader && <Loader />}
      <Polygon
        path={context.coordinates}
        options={{
          fillColor: "#dddddd",
          fillOpacity: 0.1,
          strokeColor: "#00adff",
          strokeOpacity: 1,
          strokeWeight: 2,
        }}
      />
    </GoogleMap>
  );
};
const MyMapComponent = mapEnvironment(MapLayout);

class GlobalMap extends React.PureComponent {
  state = {
    isMarkerShown: false,
  };

  componentDidMount() {
    this.delayedShowMarker();
  }

  delayedShowMarker = () => {
    setTimeout(() => {
      this.setState({ isMarkerShown: true });
    }, 3000);
  };

  handleMarkerClick = () => {
    this.setState({ isMarkerShown: false });
    this.delayedShowMarker();
  };

  render() {
    return (
      <MyMapComponent
        isMarkerShown={this.state.isMarkerShown}
        onClickMarker={this.handleMarkerClick}
      />
    );
  }
}
export default GlobalMap;
